import { ytVueGlobalStore } from "@/services/yt-vue-global-store";

const mainScreen = ytVueGlobalStore.instantGet('mainScreen');
export default {
  namespaced: true,
  state: {
    mainScreen: mainScreen || "",
  },
};
